module.exports = __webpack_public_path__ + "assets/img/feedback.b6395bd4.png";